import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost
} from "./_wsApiFetchData";

export async function searchTransaction(options, language, timeZone, cancelToken) {
  const { filters, skipPages, resultsCount } = options;
  const {
    subscriptionId,
    purchaseId,
    status,
    paymentMethodId,
    transactionId,
    beforeAt,
    afterAt,
    page,
    orderBy,
    orderDirection
  } = filters;

  const params = {
    SubscriptionId: subscriptionId || undefined,
    PurchaseId: purchaseId || undefined,
    Status: status || undefined,
    TransactionId: transactionId,
    PaymentMethodId: paymentMethodId || undefined,
    BeforeAt: beforeAt || undefined,
    AfterAt: afterAt || undefined,
    Page: parseInt(page) || 1,
    // Both optional. Absent, the endpoint answers what it always has — newest
    // first by creation — so the old admin's request is unchanged.
    OrderBy: orderBy || undefined,
    OrderDirection: orderDirection || undefined
  };

  return toPascal(await wsRequestPost('/admin/transaction/search', language, timeZone, params, null, cancelToken));
}

/**
 * What settled and what was refunded in the last `hours`, per currency.
 *
 * Added for the dashboard, which had no money figure on it — the design drew a
 * "revenue" card and it was left off rather than wired to something that merely
 * looked like money. The endpoint groups by currency and never sums across
 * them, reports settled and refunded separately with the net alongside, and
 * ignores authorisations, which are money that may yet not arrive.
 *
 * Answers `[]` on failure rather than throwing: this is one card on a page of
 * cards, and it must not be able to take the dashboard down with it.
 */
export async function getSettledSummary(hours, language, timeZone, cancelToken) {
  try {
    const data = await wsRequestGet(
      '/admin/transaction/settled-summary',
      language,
      timeZone,
      { hours },
      cancelToken
    );

    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error(`unable to read the settled summary: ${e}`);
    return [];
  }
}

export async function getTransaction(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(`/admin/transaction/${id}`, language, timeZone, null, cancelToken));
}

export async function cancelTransaction(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestPost(`/admin/transaction/${id}/cancel`, language, timeZone, null, null, cancelToken));
}

export async function generateTransactionReport(options, language, timeZone, cancelToken) {
  const { from, to } = options;

  const params = {
    From: from || undefined,
    To: to || undefined
  };

  const data = await wsRequestGet(
    "/admin/transaction/generate-report",
    language,
    timeZone,
    params,
    cancelToken
  );
  return data;
}

function toPascal(o) {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function(value) {
        if (typeof value === "object") {
          value = toPascal(value)
        }
        return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString()
        value = o[origKey]
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}
